/**
 * We use `ε`, epsilon, as a stopping criterion when we want to iterate
 * until we're "close enough". Epsilon is a very small number: for
 * simple statistics, that number is **0.0001**
 *
 * This is used in calculations like the binomialDistribution, in which
 * the process of finding a value is [iterative](https://en.wikipedia.org/wiki/Iterative_method):
 * it progresses until it is close enough.
 *
 * @type {number}
 */
const epsilon = 0.0001;
export default epsilon;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/constante/epsilon.js
 **/